import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import request from 'app/requests/Account/Account.requests'
import AccountForm from '../AccountForm'

const CreateAccount = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <AccountForm
            onSuccess={onSuccess}
            requestParam={request.create()}
        />
    )
}

export default CreateAccount
